import { useState } from "react";
import { FaPlay } from "react-icons/fa6";
import { youtubeVideoId } from "../../data/content";
import useReveal from "../../hooks/useReveal";
import SectionTitle from "../ui/SectionTitle";

export default function JoinTeaser() {
  const [playing, setPlaying] = useState(false);
  const ref = useReveal();

  return (
    <section className="bg-surface py-20 sm:py-28">
      <div className="container">
        <div ref={ref} className="reveal mx-auto max-w-3xl text-center">
          <SectionTitle
            align="center"
            eyebrow="Rejoignez la famille"
            title="Envie de faire partie de Sham Dabke ?"
            className="mx-auto"
          />
          <p className="mb-8 text-lg text-stone-200">
            Vous avez déjà pratiqué la dabké ou vous souhaitez rejoindre une troupe professionnelle
            engagée dans la transmission du patrimoine levantin&nbsp;? Envoyez-nous votre candidature.
          </p>

          <a href="#rejoignez-nous" className="btn-primary mb-10 inline-flex">
            Remplir le formulaire de candidature
          </a>

          <p className="mb-4 font-semibold text-white">Découvrez un extrait de nos cours de dabké :</p>

          <div className="relative mx-auto aspect-video max-w-2xl overflow-hidden rounded-2xl shadow-2xl shadow-black/50">
            {playing ? (
              <iframe
                src={`https://www.youtube.com/embed/${youtubeVideoId}?autoplay=1&rel=0`}
                title="Cours de dabké - Sham Dabke"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
                className="h-full w-full"
              />
            ) : (
              <button
                type="button"
                onClick={() => setPlaying(true)}
                aria-label="Lire l’extrait vidéo des cours de dabké"
                className="group relative block h-full w-full"
              >
                <img
                  src={`https://img.youtube.com/vi/${youtubeVideoId}/maxresdefault.jpg`}
                  alt="Cours de dabké - Sham Dabke"
                  loading="lazy"
                  className="h-full w-full object-cover"
                />
                <span className="absolute inset-0 bg-black/30 transition-colors group-hover:bg-black/10" />
                <span className="absolute left-1/2 top-1/2 flex h-20 w-20 -translate-x-1/2 -translate-y-1/2 animate-playPulse items-center justify-center rounded-full bg-gold-500 text-ink">
                  <FaPlay size={28} className="ml-1" />
                </span>
              </button>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
